import { dataUpgradeSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUpgradeSolid = /*#__PURE__*/createIcon(dataUpgradeSolid)
export default IconUpgradeSolid
